import { GET_NOTES, CREATE_NOTE, DELETE_NOTE } from "./types";

const initialState = {
    notes: [],
};

export const noteReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTES:
            return { ...state, notes: action.payload };
        case CREATE_NOTE:
            return { ...state, notes: state.notes.concat([action.payload]) };
        case DELETE_NOTE:
            return {
                ...state,
                notes: state.notes.filter((note) => note._id !== action.payload),
            };
        default:
            return state;
    }
};
